export default "__VITE_ASSET__8127a6e0__"